import { lazyWithPreload } from "@/lib/lazy";

/**
 * Útvonalanként külön töltődő oldalak. A főoldal nincs itt: az az első festéshez kell; a
 * többi csak akkor töltődik le, amikor a látogató odanavigál - vagy amikor előtöltjük
 * (`preloadWhenIdle`). Az admin keret is itt van: a vendégeknek nem kell letölteniük (a
 * foglalás-állapot segédek a date-fns-t is behúznák). Az admin szekciók ugyanígy:
 * `pages/admin/sections.tsx`.
 */
export const AdminLayout = lazyWithPreload(() =>
  import("@/components/layout/AdminLayout").then((m) => ({ default: m.AdminLayout })),
);
export const BookingPage = lazyWithPreload(() =>
  import("./BookingPage").then((m) => ({ default: m.BookingPage })),
);
export const LoginPage = lazyWithPreload(() =>
  import("./LoginPage").then((m) => ({ default: m.LoginPage })),
);
export const RegisterPage = lazyWithPreload(() =>
  import("./RegisterPage").then((m) => ({ default: m.RegisterPage })),
);
export const MyBookingsPage = lazyWithPreload(() =>
  import("./MyBookingsPage").then((m) => ({ default: m.MyBookingsPage })),
);
export const ProfilePage = lazyWithPreload(() =>
  import("./ProfilePage").then((m) => ({ default: m.ProfilePage })),
);
export const SetupAdminPage = lazyWithPreload(() =>
  import("./SetupAdminPage").then((m) => ({ default: m.SetupAdminPage })),
);
export const PaymentResultPage = lazyWithPreload(() =>
  import("./PaymentResultPage").then((m) => ({ default: m.PaymentResultPage })),
);
/** A számla-szerkesztő: saját oldal az admin kereten kívül, ezért nem a `sections.tsx`-ben. */
export const InvoiceEditorPage = lazyWithPreload(() =>
  import("./InvoiceEditorPage").then((m) => ({ default: m.InvoiceEditorPage })),
);
